import { API } from "../api";

export const money = (n) => new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(Number(n) || 0);

export const crm = async (path, { method = "GET", body, token } = {}) => {
  const res = await fetch(`${API}/crm${path}`, {
    method,
    headers: { ...(body ? { "Content-Type": "application/json" } : {}), ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const d = data.detail;
    const e = new Error(typeof d === "string" ? d : Array.isArray(d) ? d.map((x) => x.msg).join(" ") : "Ocurrió un error");
    e.status = res.status;
    throw e;
  }
  return data;
};

export const STATUS = {
  prospecto: { label: "Prospecto", color: "#64748B" },
  contactado: { label: "Contactado", color: "#0EA5E9" },
  cotizado: { label: "Cotizado", color: "#8B5CF6" },
  negociacion: { label: "Negociación", color: "#F59E0B" },
  cliente: { label: "Cliente", color: "#10B981" },
  perdido: { label: "Perdido", color: "#EF4444" },
};
export const QSTATUS = { borrador: "Borrador", enviada: "Enviada", aceptada: "Aceptada", rechazada: "Rechazada" };

export const fmtDate = (d) => (d ? new Date(d.endsWith?.("Z") || d.includes?.("+") ? d : `${d}Z`).toLocaleString("es-MX", { dateStyle: "medium", timeStyle: "short" }) : "");

// Envía por WhatsApp: si el automático no está listo, abre WhatsApp con el mensaje (ventana abierta antes para iPhone).
export const preOpen = () => window.open("", "_blank");
export const handleWa = (res, w) => {
  if (res.ok) {
    w?.close();
    return res.message || "Enviado por WhatsApp";
  }
  if (res.fallback_url) {
    if (w) w.location.href = res.fallback_url;
    else window.open(res.fallback_url, "_blank");
  } else w?.close();
  return res.code === "not_configured" ? "Abriendo WhatsApp…" : `${res.message}. Abriendo WhatsApp…`;
};
